import { render, staticRenderFns } from "./LoadingBox.vue?vue&type=template&id=f5b646ba&scoped=true"
import script from "./LoadingBox.vue?vue&type=script&lang=js"
export * from "./LoadingBox.vue?vue&type=script&lang=js"
import style0 from "./LoadingBox.vue?vue&type=style&index=0&id=f5b646ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5b646ba",
  null
  
)

export default component.exports